<template>
  <div class="enquiry-dashboard">
    <v-row>
      <v-col md="12">
        <v-card flat class="py-4">
          <v-layout class="dashboard-top-button px-3 overflow-hidden">
            <v-flex
              v-for="(item, index) in enquirySummaryData"
              :key="index"
              class="mx-4"
            >
              <v-card
                outlined
                :color="`${item.color} lighten-5`"
                :style="`border-color: ${getBgColor(item.color)}!important`"
              >
                <v-card-text>
                  <div class="text-h6 fw-500">{{ item.title }}</div>
                  <div class="d-flex align-center">
                    <div
                      :class="`text-h4 font-weight-bold ${item.textColor} mt-1`"
                    >
                      {{ item.value }}
                    </div>
                    <v-spacer />
                    <v-icon :size="40" :color="item.iconColor">
                      {{ item.icon }}
                    </v-icon>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-col>
      <v-col md="4">
        <v-card flat height="100%">
          <v-card-text>
            <div class="text-h5 font-weight-bold text-uppercase pt-4">
              Enquiry Category
            </div>
            <div class="font-size-20 grey--text mb-5">
              Enquire Impact Reporting Software helps your team make informed
              decisions, communicate results, and prove social impact outcomes
              with ease.
            </div>
            <div class="card-custom dash_card">
              <div class="card-body p-0">
                <div
                  id="kt_stats_widget_11_chart"
                  class="card-rounded-bottom mid_part"
                  data-color="danger"
                >
                  <div
                    class="dash_bottom d-flex align-items-center justify-content-between pb-2 flex-grow-1"
                  >
                    <div class="text-left v_list">
                      <ul class="px-2 d-flex flex-wrap w-100">
                        <li
                          class="cursor-pointer w-50 pe-4"
                          v-for="(issue, index) in enguiryCategory"
                          :key="index"
                          @click="onBarClick(index)"
                        >
                          <div>
                            <span
                              class="svg-icon svg-icon-xl"
                              :class="{
                                'svg-icon-primary': activeIndex === index,
                              }"
                            >
                              <inline-svg
                                :src="$assetURL('media/custom-svg/right.svg')"
                              />
                            </span>
                            <strong
                              :class="{
                                'grey--text': activeIndex != index,
                              }"
                              >{{ issue.title }}</strong
                            >
                            <v-icon
                              size="24"
                              class="ms-1"
                              v-if="activeIndex === index"
                              color="green"
                              >mdi-check-circle</v-icon
                            >
                          </div>
                          <div class="vdnum" v-if="countLoading">
                            <v-progress-circular
                              indeterminate
                              size="24"
                              color="#3a6afd"
                            ></v-progress-circular>
                          </div>
                          <span
                            v-else
                            :style="{ backgroundColor: issue.color }"
                            >{{ issue.count }}</span
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="4" v-if="false">
        <v-card flat class="px-3" height="100%">
          <v-card-text>
            <div class="">
              <div class="text-h5 font-weight-bold text-uppercase pt-4">
                Enquiry by Status
              </div>
              <div class="font-size-20 grey--text mb-5">
                It is a metric that shows the number of tickets that are not in
                a "Resolved" or "Closed" status.
              </div>
              <v-spacer />
            </div>
            <div id="chart">
              <apexchart
                type="donut"
                width="400"
                :options="ticketsByStatuschartOptions"
                :series="ticketsByStatusseries"
                @dataPointSelection="onBarClick"
              ></apexchart>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="4">
        <v-card flat class="px-3" height="100%">
          <v-card-text>
            <div class="align-center">
              <div class="text-h5 font-weight-bold text-uppercase pt-4">
                Enquiry by Priority
              </div>
              <div class="font-size-20 grey--text mb-5">
                It's a metric that shows the number of unresolved support
                tickets for each priority level.
              </div>
              <v-spacer />
            </div>
            <div id="chart">
              <apexchart
                type="donut"
                width="400"
                :options="ticketsByPrioritychartOptions"
                :series="filteredticketsByPriorityseries"
                @dataPointSelection="onBarClickEnquiryPriority"
              ></apexchart>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="4">
        <v-card flat class="px-3" height="100%">
          <v-card-text>
            <div class="align-center">
              <div class="text-h5 font-weight-bold text-uppercase pt-4">
                Enquiry by Impact
              </div>
              <div class="font-size-20 grey--text">
                It's a metric that shows the number of unresolved support
                tickets for each ipact level.
              </div>
              <v-spacer />
            </div>
            <div id="chart">
              <apexchart
                type="donut"
                width="400"
                :options="impactchartOptions"
                :series="filterimpactseries"
                @dataPointSelection="onBarClickEnquiryImpect"
              ></apexchart>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12">
        <v-card flat class="px-4">
          <v-card-text>
            <div class="d-flex align-center">
              <div class="text-h5 font-weight-bold text-uppercase pt-4">
                Enquiry Category-wise
                <v-chip class="mx-2 white--text" color="green"> Top 5 </v-chip>
              </div>
              <v-spacer />
              <v-btn
                outlined
                color="blue"
                class="text-start rounded custom-menu-select py-1 btn-shadow-hover me-3"
              >
                <v-select
                  :items="durationList"
                  v-model="isDuration"
                  hide-details
                  :disabled="issueCountLoadingNew"
                  item-color="cyan"
                  class="pt-0 mt-0 black--texr"
                >
                </v-select>
              </v-btn>
            </div>
            <div id="chart" class="enquiry-category">
              <apexchart
                type="bar"
                height="350"
                :options="categoryTicketschartOptions"
                :series="categoryTicketsseries"
                @dataPointSelection="onBarClickEnquiryCategory"
              ></apexchart>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="8">
        <v-card flat class="px-3">
          <v-card-text>
            <div class="d-flex align-center">
              <div class="text-h5 font-weight-bold text-uppercase pt-4">
                New & Closed Jobs for 6 months
              </div>
              <v-spacer />
              <v-btn
                outlined
                color="blue"
                class="text-start rounded custom-menu-select py-1 btn-shadow-hover me-3"
              >
                <v-select
                  :items="durationList"
                  v-model="isDuration"
                  hide-details
                  :disabled="issueCountLoadingNew"
                  item-color="cyan"
                  class="pt-0 mt-0 black--texr"
                >
                </v-select>
              </v-btn>
            </div>
            <div id="chart">
              <apexchart
                type="line"
                height="350"
                :options="newClosedJobschartOptions"
                :series="newClosedJobsseries"
              ></apexchart>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="4">
        <v-card flat class="px-3 pb-2" height="100%">
          <v-card-text>
            <div class="mb-4">
              <div class="text-h5 font-weight-bold text-uppercase pt-4">
                Response Time
              </div>
              <div class="font-size-20 grey--text">
                Average resolution time is calculated by dividing the total
                resolution time for all tickets by the number of tickets
              </div>
              <v-spacer />
            </div>
            <v-card
              color="cyan lighten-5"
              flat
              class="d-inline-block me-2 mb-2"
              v-for="n in 1"
              :key="n"
            >
              <v-card-text>
                <div
                  class="text-h5 cyan--text font-weight-bold mt-1 text-center"
                >
                  <v-icon color="cyan" size="50" class="d-block mb-2"
                    >mdi-timetable</v-icon
                  >
                  {{ resolveDay }} Days, {{ resolveHours }} Hrs,<br />
                  {{ resolveMins }} Mins
                </div>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "ProjectStatus",
  data() {
    return {
      countLoading: false,
      issueCountLoadingNew: false,
      activeIndex: null,
      enguiryCategory: [
        { title: "Login Issues", count: 18, color: "green" },
        { title: "Software Bugs", count: 25, color: "blue" },
        { title: "App Issues", count: 45, color: "cyan" },
        { title: "Integrations Failures", count: 33, color: "orange" },
        { title: "API Issues", count: 25, color: "gray" },
        { title: "Service Cancellation", count: 4, color: "green" },
        { title: "Invoice Enquiries", count: 12, color: "blue" },
        { title: "Payment Issues", count: 5, color: "cyan" },
        { title: "Refund Requests", count: 14, color: "orange" },
        { title: "Sales Enquiries", count: 13, color: "red" },
      ],
      resolveDay: 10,
      resolveHours: 4,
      resolveMins: 50,
      enquirySummaryData: [
        {
          title: "Open",
          value: 42,
          color: "indigo",
          textColor: "indigo--text",
          iconColor: "indigo",
          icon: "mdi-account-question-outline",
        },
        {
          title: "In Progress",
          value: 12,
          color: "yellow",
          textColor: "yellow--text",
          iconColor: "yellow",
          icon: "mdi-account-question-outline",
        },
        {
          title: "On Hold",
          value: 1,
          color: "orange",
          textColor: "orange--text",
          iconColor: "orange",
          icon: "mdi-account-question-outline",
        },
        {
          title: "Completed",
          value: 4,
          color: "green",
          textColor: "green--text",
          iconColor: "green",
          icon: "mdi-account-question-outline",
        },
        {
          title: "Cancelled",
          value: 1,
          color: "red",
          textColor: "red--text",
          iconColor: "red",
          icon: "mdi-account-question-outline",
        },
      ],
      newClosedJobsseries: [
        {
          name: "New Jobs",
          data: [28, 29, 33, 36, 32, 32],
        },
        {
          name: "Closed Jobs",
          data: [12, 11, 14, 18, 17, 13],
        },
      ],
      newClosedJobschartOptions: {
        chart: {
          height: 350,
          type: "line",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ["#4CAF50", "#F44336"],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Average New & Closed Jobs",
          align: "left",
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
          title: {
            text: "Month",
          },
        },
        yaxis: {
          title: {
            text: "Jobs",
          },
          min: 5,
          max: 40,
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: -25,
          offsetX: -5,
        },
      },
      filteredticketsByPriorityseries: [],
      ticketsByPriorityseries: [43, 12, 15],
      ticketsByPrioritychartOptions: {
        chart: {
          width: 425,
          type: "donut",
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
          },
        },
        labels: ["Low", "Medium", "High"],
        colors: ["#c62828", "#e65100", "#558b2f"],
        dataLabels: {
          enabled: true,
        },

        fill: {
          type: "gradient",
        },
        legend: {
          formatter: function (val, opts) {
            return val + " - " + opts.w.globals.series[opts.seriesIndex];
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                show: false,
                position: "bottom",
              },
            },
          },
        ],
      },
      filterimpactseries: [],
      impactseries: [43, 12, 15],
      impactchartOptions: {
        chart: {
          width: 425,
          type: "donut",
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
          },
        },
        colors: ["#c62828", "#e65100", "#558b2f"],
        labels: ["Highest", "Medium", "Lowest"],
        dataLabels: {
          enabled: true,
        },

        fill: {
          type: "gradient",
        },
        legend: {
          formatter: function (val, opts) {
            return val + " - " + opts.w.globals.series[opts.seriesIndex];
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                show: false,
                position: "bottom",
              },
            },
          },
        ],
      },

      ticketsByStatusseries: [42, 12, 1, 4, 1],
      ticketsByStatuschartOptions: {
        chart: {
          width: 425,
          type: "donut",
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
          },
        },
        labels: [
          "New",
          "Open",
          "In-Progress",
          "Overdue",
          "Closed",
          "Escalated",
        ],
        dataLabels: {
          enabled: false,
        },
        fill: {
          type: "gradient",
        },
        legend: {
          formatter: function (val, opts) {
            return val + " - " + opts.w.globals.series[opts.seriesIndex];
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                show: false,
                position: "bottom",
              },
            },
          },
        ],
      },
      categoryTicketsseries: [
        {
          name: "New",
          data: [24, 45, 31, 22, 22],
        },
        {
          name: "Open",
          data: [44, 55, 41, 12, 32],
        },
        {
          name: "In-Progress",
          data: [53, 32, 33, 17, 30],
        },
        {
          name: "Overdue",
          data: [12, 17, 11, 12, 10],
        },
        {
          name: "Closed",
          data: [9, 7, 5, 8, 31],
        },
        {
          name: "Escalated",
          data: [9, 7, 5, 8, 23],
        },
      ],
      categoryTicketschartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 0,
                style: {
                  fontSize: "13px",
                  fontWeight: 900,
                },
              },
            },
          },
        },
        colors: [
          "#26a0fc",
          "#a9a9a9",
          "#ffff00",
          "#ffa500",
          "#558b2f",
          "#c62828",
        ],
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        title: {
          text: "New and open tickets categorized by type, showing the count and status for each category.New and open tickets categorized by type, showing the count and status for each category.",
          align: "left",
        },
        xaxis: {
          categories: [
            "Login Issues",
            "Software Bugs",
            "App Issues",
            "Integrations Failures",
            "API Issues",
          ],
          labels: {
            formatter: function (val) {
              return val + "";
            },
          },
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + "Tickets";
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
        },
      },
      categoryList: [
        { text: "Open", value: "open" },
        { text: "Closed", value: "closed" },
        { text: "Overdue", value: "overdue" },
      ],
      isCategory: "open",
      durationList: [
        { text: "This Week", value: "this_week" },
        { text: "This Month", value: "this_month" },
        { text: "Last 3 Month", value: "last-3month" },
        { text: "Last 6 Month", value: "last-6month" },
      ],
      isDuration: "this_month",
      network: 63,
      software: 46,
      other: 43,
      hardware: 33,
    };
  },
  created() {
    this.filteredticketsByPriorityseries = this.ticketsByPriorityseries;
    this.filterimpactseries = this.impactseries;
  },
  methods: {
    onBarClick(index) {
      this.ticketsByPrioritychartOptions = {
        ...this.ticketsByPrioritychartOptions,
        colors: ["#c62828", "#e65100", "#558b2f"],
      };
      this.impactchartOptions = {
        ...this.impactchartOptions,
        colors: ["#c62828", "#e65100", "#558b2f"],
      };
      // console.log({ config });
      // const clickedIndex = config.dataPointIndex;
      switch (index) {
        case 0:
          // this.jobType = "open";
          this.activeIndex = index;
          this.filteredticketsByPriorityseries = [44, 17, 10];
          this.filterimpactseries = [14, 17, 20];
          this.resolveDay = 20;
          this.resolveHours = 9;
          this.resolveMins = 30;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [18, 19, 13, 36, 12, 22],
            },
            {
              name: "Closed Jobs",
              data: [22, 21, 24, 18, 27, 3],
            },
          ];
          this.categoryTicketsseries = [
            {
              name: "Open",
              data: [23, 25, 41, 12, 32],
            },
            {
              name: "In-Progress",
              data: [11, 73, 29, 11, 22],
            },
            {
              name: "Completed",
              data: [43, 32, 23, 15, 17],
            },
            {
              name: "Cancelled",
              data: [22, 13, 26, 24, 14],
            },
            {
              name: "Closed",
              data: [13, 22, 33, 21, 17],
            },
          ];
          // this.firstColumnIssues = [
          //   { title: "Login Issues", count: 2, color: "green" },
          //   { title: "Software Bugs", count: 20, color: "blue" },
          //   { title: "App Issues", count: 35, color: "cyan" },
          //   { title: "Integrations Failures", count: 23, color: "orange" },
          //   { title: "API Issues", count: 22, color: "gray" },
          // ];
          // this.secondColumnIssues = [
          //   { title: "Service Cancellation", count: 24, color: "green" },
          //   { title: "Invoice Enquiries", count: 1, color: "blue" },
          //   { title: "Payment Issues", count: 15, color: "cyan" },
          //   { title: "Refund Requests", count: 24, color: "orange" },
          //   { title: "Sales Enquiries", count: 3, color: "gray" },
          // ];
          break;
        case 1:
          // this.jobType = "in-progress";
          this.activeIndex = index;
          this.filteredticketsByPriorityseries = [53, 20, 19];
          this.filterimpactseries = [23, 28, 19];
          this.resolveDay = 15;
          this.resolveHours = 7;
          this.resolveMins = 20;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [38, 39, 13, 36, 33, 29],
            },
            {
              name: "Closed Jobs",
              data: [29, 28, 24, 18, 17, 23],
            },
          ];
          this.categoryTicketsseries = [
            {
              name: "Open",
              data: [13, 35, 41, 16, 23],
            },
            {
              name: "In-Progress",
              data: [43, 32, 23, 15, 17],
            },
            {
              name: "Completed",
              data: [11, 73, 29, 11, 22],
            },
            {
              name: "Cancelled",
              data: [13, 22, 33, 21, 17],
            },
            {
              name: "Closed",
              data: [22, 13, 26, 24, 14],
            },
          ];
          break;
        case 2:
          // this.jobType = "hold";
          this.activeIndex = index;
          this.filteredticketsByPriorityseries = [23, 42, 55];
          this.filterimpactseries = [33, 62, 15];
          this.resolveDay = 18;
          this.resolveHours = 2;
          this.resolveMins = 25;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [29, 28, 43, 18, 27, 23],
            },
            {
              name: "Closed Jobs",
              data: [38, 39, 13, 36, 33, 29],
            },
          ];
          this.categoryTicketsseries = [
            {
              name: "Open",
              data: [33, 35, 21, 13, 16],
            },
            {
              name: "In-Progress",
              data: [13, 22, 33, 32, 23],
            },
            {
              name: "Completed",
              data: [22, 13, 26, 32, 23],
            },
            {
              name: "Cancelled",
              data: [13, 22, 33, 21, 17],
            },
            {
              name: "Closed",
              data: [22, 13, 26, 24, 14],
            },
          ];
          break;
        case 3:
          // this.jobType = "completed";
          this.activeIndex = index;
          this.filteredticketsByPriorityseries = [49, 62, 25];
          this.filterimpactseries = [39, 12, 35];
          this.resolveDay = 29;
          this.resolveHours = 1;
          this.resolveMins = 45;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [30, 39, 33, 26, 43, 39],
            },
            {
              name: "Closed Jobs",
              data: [39, 38, 24, 38, 27, 13],
            },
          ];
          this.categoryTicketsseries = [
            {
              name: "Open",
              data: [13, 35, 25, 21, 31],
            },
            {
              name: "In-Progress",
              data: [22, 13, 26, 12, 23],
            },
            {
              name: "Completed",
              data: [13, 22, 33, 11, 22],
            },
            {
              name: "Cancelled",
              data: [13, 22, 33, 21, 17],
            },
            {
              name: "Closed",
              data: [22, 13, 26, 24, 14],
            },
          ];
          break;
        case 4:
          // this.jobType = "cancelled";
          this.activeIndex = index;
          this.filteredticketsByPriorityseries = [23, 42, 55];
          this.filterimpactseries = [30, 42, 45];
          this.resolveDay = 29;
          this.resolveHours = 8;
          this.resolveMins = 54;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [36, 19, 43, 54, 33, 28],
            },
            {
              name: "Closed Jobs",
              data: [35, 29, 33, 38, 27, 40],
            },
          ];
          this.categoryTicketsseries = [
            {
              name: "Open",
              data: [13, 12, 33, 11, 7],
            },
            {
              name: "In-Progress",
              data: [15, 22, 31, 21, 17],
            },
            {
              name: "Completed",
              data: [16, 22, 30, 21, 19],
            },
            {
              name: "Cancelled",
              data: [16, 28, 33, 20, 7],
            },
            {
              name: "Closed",
              data: [22, 13, 26, 24, 14],
            },
          ];
          break;
        case 5:
          // this.jobType = "open";
          this.activeIndex = index;
          this.filteredticketsByPriorityseries = [44, 17, 10];
          this.filterimpactseries = [14, 17, 20];
          this.resolveDay = 20;
          this.resolveHours = 9;
          this.resolveMins = 30;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [18, 19, 13, 36, 12, 22],
            },
            {
              name: "Closed Jobs",
              data: [22, 21, 24, 18, 27, 3],
            },
          ];
          this.categoryTicketsseries = [
            {
              name: "Open",
              data: [23, 25, 41, 12, 32],
            },
            {
              name: "In-Progress",
              data: [11, 73, 29, 11, 22],
            },
            {
              name: "Completed",
              data: [43, 32, 23, 15, 17],
            },
            {
              name: "Cancelled",
              data: [22, 13, 26, 24, 14],
            },
            {
              name: "Closed",
              data: [13, 22, 33, 21, 17],
            },
          ];
          break;
        case 6:
          // this.jobType = "in-progress";
          this.activeIndex = index;
          this.filteredticketsByPriorityseries = [53, 20, 19];
          this.filterimpactseries = [23, 28, 19];
          this.resolveDay = 15;
          this.resolveHours = 7;
          this.resolveMins = 20;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [38, 39, 13, 36, 33, 29],
            },
            {
              name: "Closed Jobs",
              data: [29, 28, 24, 18, 17, 23],
            },
          ];
          this.categoryTicketsseries = [
            {
              name: "Open",
              data: [13, 35, 41, 16, 23],
            },
            {
              name: "In-Progress",
              data: [43, 32, 23, 15, 17],
            },
            {
              name: "Completed",
              data: [11, 73, 29, 11, 22],
            },
            {
              name: "Cancelled",
              data: [13, 22, 33, 21, 17],
            },
            {
              name: "Closed",
              data: [22, 13, 26, 24, 14],
            },
          ];
          break;
        case 7:
          // this.jobType = "hold";
          this.activeIndex = index;
          this.filteredticketsByPriorityseries = [23, 42, 55];
          this.filterimpactseries = [33, 62, 15];
          this.resolveDay = 18;
          this.resolveHours = 2;
          this.resolveMins = 25;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [29, 28, 43, 18, 27, 23],
            },
            {
              name: "Closed Jobs",
              data: [38, 39, 13, 36, 33, 29],
            },
          ];
          this.categoryTicketsseries = [
            {
              name: "Open",
              data: [33, 35, 21, 13, 16],
            },
            {
              name: "In-Progress",
              data: [13, 22, 33, 32, 23],
            },
            {
              name: "Completed",
              data: [22, 13, 26, 32, 23],
            },
            {
              name: "Cancelled",
              data: [13, 22, 33, 21, 17],
            },
            {
              name: "Closed",
              data: [22, 13, 26, 24, 14],
            },
          ];
          break;
        case 8:
          // this.jobType = "completed";
          this.activeIndex = index;
          this.filteredticketsByPriorityseries = [49, 62, 25];
          this.filterimpactseries = [39, 12, 35];
          this.resolveDay = 29;
          this.resolveHours = 1;
          this.resolveMins = 45;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [30, 39, 33, 26, 43, 39],
            },
            {
              name: "Closed Jobs",
              data: [39, 38, 24, 38, 27, 13],
            },
          ];
          this.categoryTicketsseries = [
            {
              name: "Open",
              data: [13, 35, 25, 21, 31],
            },
            {
              name: "In-Progress",
              data: [22, 13, 26, 12, 23],
            },
            {
              name: "Completed",
              data: [13, 22, 33, 11, 22],
            },
            {
              name: "Cancelled",
              data: [13, 22, 33, 21, 17],
            },
            {
              name: "Closed",
              data: [22, 13, 26, 24, 14],
            },
          ];
          break;
        case 9:
          // this.jobType = "cancelled";
          this.activeIndex = index;
          this.filteredticketsByPriorityseries = [23, 42, 55];
          this.filterimpactseries = [30, 42, 45];
          this.resolveDay = 29;
          this.resolveHours = 8;
          this.resolveMins = 54;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [36, 19, 43, 54, 33, 28],
            },
            {
              name: "Closed Jobs",
              data: [35, 29, 33, 38, 27, 40],
            },
          ];
          this.categoryTicketsseries = [
            {
              name: "Open",
              data: [13, 12, 33, 11, 7],
            },
            {
              name: "In-Progress",
              data: [15, 22, 31, 21, 17],
            },
            {
              name: "Completed",
              data: [16, 22, 30, 21, 19],
            },
            {
              name: "Cancelled",
              data: [16, 28, 33, 20, 7],
            },
            {
              name: "Closed",
              data: [22, 13, 26, 24, 14],
            },
          ];
          break;
        default:
        // this.jobType = "open";
      }
    },
    onBarClickEnquiryPriority(event, chartContext, config) {
      // console.log({ config });
      this.activeIndex = null;
      this.impactchartOptions = {
        ...this.impactchartOptions,
        colors: ["#c62828", "#e65100", "#558b2f"],
      };
      const clickedIndex = config.dataPointIndex;
      switch (clickedIndex) {
        case 0:
          this.jobType = "low";
          this.filterimpactseries = [14, 17, 20];
          this.resolveDay = 20;
          this.resolveHours = 9;
          this.resolveMins = 30;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [18, 19, 13, 36, 12, 22],
            },
            {
              name: "Closed Jobs",
              data: [22, 21, 24, 18, 27, 3],
            },
          ];
          this.categoryTicketsseries = [
            {
              name: "Open",
              data: [23, 25, 41, 12, 32],
            },
            {
              name: "In-Progress",
              data: [11, 73, 29, 11, 22],
            },
            {
              name: "Completed",
              data: [43, 32, 23, 15, 17],
            },
            {
              name: "Cancelled",
              data: [22, 13, 26, 24, 14],
            },
            {
              name: "Closed",
              data: [13, 22, 33, 21, 17],
            },
          ];
          this.enguiryCategory = [
            { title: "Login Issues", count: 28, color: "green" },
            { title: "Software Bugs", count: 15, color: "blue" },
            { title: "App Issues", count: 35, color: "cyan" },
            { title: "Integrations Failures", count: 23, color: "orange" },
            { title: "API Issues", count: 15, color: "gray" },
            { title: "Service Cancellation", count: 14, color: "green" },
            { title: "Invoice Enquiries", count: 22, color: "blue" },
            { title: "Payment Issues", count: 15, color: "cyan" },
            { title: "Refund Requests", count: 4, color: "orange" },
            { title: "Sales Enquiries", count: 3, color: "red" },
          ];
          break;
        case 1:
          this.jobType = "medium";
          this.filterimpactseries = [23, 28, 19];
          this.resolveDay = 15;
          this.resolveHours = 7;
          this.resolveMins = 20;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [38, 39, 13, 36, 33, 29],
            },
            {
              name: "Closed Jobs",
              data: [29, 28, 24, 18, 17, 23],
            },
          ];
          this.categoryTicketsseries = [
            {
              name: "Open",
              data: [13, 35, 41, 16, 23],
            },
            {
              name: "In-Progress",
              data: [43, 32, 23, 15, 17],
            },
            {
              name: "Completed",
              data: [11, 73, 29, 11, 22],
            },
            {
              name: "Cancelled",
              data: [13, 22, 33, 21, 17],
            },
            {
              name: "Closed",
              data: [22, 13, 26, 24, 14],
            },
          ];
          this.enguiryCategory = [
            { title: "Login Issues", count: 28, color: "green" },
            { title: "Software Bugs", count: 45, color: "blue" },
            { title: "App Issues", count: 25, color: "cyan" },
            { title: "Integrations Failures", count: 13, color: "orange" },
            { title: "API Issues", count: 15, color: "gray" },
            { title: "Service Cancellation", count: 24, color: "green" },
            { title: "Invoice Enquiries", count: 22, color: "blue" },
            { title: "Payment Issues", count: 25, color: "cyan" },
            { title: "Refund Requests", count: 14, color: "orange" },
            { title: "Sales Enquiries", count: 23, color: "red" },
          ];
          break;
        case 2:
          this.jobType = "high";
          this.filterimpactseries = [33, 62, 15];
          this.resolveDay = 18;
          this.resolveHours = 2;
          this.resolveMins = 25;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [29, 28, 43, 18, 27, 23],
            },
            {
              name: "Closed Jobs",
              data: [38, 39, 13, 36, 33, 29],
            },
          ];
          this.categoryTicketsseries = [
            {
              name: "Open",
              data: [33, 35, 21, 13, 16],
            },
            {
              name: "In-Progress",
              data: [13, 22, 33, 32, 23],
            },
            {
              name: "Completed",
              data: [22, 13, 26, 32, 23],
            },
            {
              name: "Cancelled",
              data: [13, 22, 33, 21, 17],
            },
            {
              name: "Closed",
              data: [22, 13, 26, 24, 14],
            },
          ];
          this.enguiryCategory = [
            { title: "Login Issues", count: 18, color: "green" },
            { title: "Software Bugs", count: 25, color: "blue" },
            { title: "App Issues", count: 45, color: "cyan" },
            { title: "Integrations Failures", count: 33, color: "orange" },
            { title: "API Issues", count: 25, color: "gray" },
            { title: "Service Cancellation", count: 4, color: "green" },
            { title: "Invoice Enquiries", count: 12, color: "blue" },
            { title: "Payment Issues", count: 5, color: "cyan" },
            { title: "Refund Requests", count: 14, color: "orange" },
            { title: "Sales Enquiries", count: 13, color: "red" },
          ];
          break;
        default:
          this.jobStatus = "low";
      }
      this.disableOtherPriorityBars(clickedIndex);
    },
    disableOtherPriorityBars(selectedIndex) {
      const defaultColors = ["#c62828", "#e65100", "#558b2f"];
      const preColor = defaultColors.map((color, index) =>
        index === selectedIndex ? color : "#d3d3d3"
      );
      this.ticketsByPrioritychartOptions = {
        ...this.ticketsByPrioritychartOptions,
        colors: preColor,
      };
    },
    onBarClickEnquiryImpect(event, chartContext, config) {
      // console.log({ config });
      this.activeIndex = null;
      this.ticketsByPrioritychartOptions = {
        ...this.ticketsByPrioritychartOptions,
        colors: ["#c62828", "#e65100", "#558b2f"],
      };

      const clickedIndex = config.dataPointIndex;
      switch (clickedIndex) {
        case 0:
          this.jobType = "low";
          this.filteredticketsByPriorityseries = [39, 42, 35];
          this.resolveDay = 20;
          this.resolveHours = 9;
          this.resolveMins = 30;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [18, 19, 13, 36, 12, 22],
            },
            {
              name: "Closed Jobs",
              data: [22, 21, 24, 18, 27, 3],
            },
          ];
          this.categoryTicketsseries = [
            {
              name: "Open",
              data: [23, 25, 41, 12, 32],
            },
            {
              name: "In-Progress",
              data: [11, 73, 29, 11, 22],
            },
            {
              name: "Completed",
              data: [43, 32, 23, 15, 17],
            },
            {
              name: "Cancelled",
              data: [22, 13, 26, 24, 14],
            },
            {
              name: "Closed",
              data: [13, 22, 33, 21, 17],
            },
          ];
          this.enguiryCategory = [
            { title: "Login Issues", count: 28, color: "green" },
            { title: "Software Bugs", count: 45, color: "blue" },
            { title: "App Issues", count: 25, color: "cyan" },
            { title: "Integrations Failures", count: 13, color: "orange" },
            { title: "API Issues", count: 15, color: "gray" },
            { title: "Service Cancellation", count: 24, color: "green" },
            { title: "Invoice Enquiries", count: 22, color: "blue" },
            { title: "Payment Issues", count: 25, color: "cyan" },
            { title: "Refund Requests", count: 14, color: "orange" },
            { title: "Sales Enquiries", count: 23, color: "red" },
          ];
          break;
        case 1:
          this.jobType = "medium";
          this.filteredticketsByPriorityseries = [39, 22, 15];
          this.resolveDay = 15;
          this.resolveHours = 7;
          this.resolveMins = 20;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [38, 39, 13, 36, 33, 29],
            },
            {
              name: "Closed Jobs",
              data: [29, 28, 24, 18, 17, 23],
            },
          ];
          this.categoryTicketsseries = [
            {
              name: "Open",
              data: [13, 35, 41, 16, 23],
            },
            {
              name: "In-Progress",
              data: [43, 32, 23, 15, 17],
            },
            {
              name: "Completed",
              data: [11, 73, 29, 11, 22],
            },
            {
              name: "Cancelled",
              data: [13, 22, 33, 21, 17],
            },
            {
              name: "Closed",
              data: [22, 13, 26, 24, 14],
            },
          ];
          break;
        case 2:
          this.jobType = "high";
          this.filteredticketsByPriorityseries = [49, 62, 25];
          this.resolveDay = 18;
          this.resolveHours = 2;
          this.resolveMins = 25;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [29, 28, 43, 18, 27, 23],
            },
            {
              name: "Closed Jobs",
              data: [38, 39, 13, 36, 33, 29],
            },
          ];
          this.categoryTicketsseries = [
            {
              name: "Open",
              data: [33, 35, 21, 13, 16],
            },
            {
              name: "In-Progress",
              data: [13, 22, 33, 32, 23],
            },
            {
              name: "Completed",
              data: [22, 13, 26, 32, 23],
            },
            {
              name: "Cancelled",
              data: [13, 22, 33, 21, 17],
            },
            {
              name: "Closed",
              data: [22, 13, 26, 24, 14],
            },
          ];
          this.enguiryCategory = [
            { title: "Login Issues", count: 28, color: "green" },
            { title: "Software Bugs", count: 15, color: "blue" },
            { title: "App Issues", count: 35, color: "cyan" },
            { title: "Integrations Failures", count: 23, color: "orange" },
            { title: "API Issues", count: 15, color: "gray" },
            { title: "Service Cancellation", count: 14, color: "green" },
            { title: "Invoice Enquiries", count: 22, color: "blue" },
            { title: "Payment Issues", count: 15, color: "cyan" },
            { title: "Refund Requests", count: 4, color: "orange" },
            { title: "Sales Enquiries", count: 3, color: "red" },
          ];
          this.enguiryCategory = [
            { title: "Login Issues", count: 38, color: "green" },
            { title: "Software Bugs", count: 35, color: "blue" },
            { title: "App Issues", count: 25, color: "cyan" },
            { title: "Integrations Failures", count: 23, color: "orange" },
            { title: "API Issues", count: 25, color: "gray" },
            { title: "Service Cancellation", count: 24, color: "green" },
            { title: "Invoice Enquiries", count: 12, color: "blue" },
            { title: "Payment Issues", count: 5, color: "cyan" },
            { title: "Refund Requests", count: 14, color: "orange" },
            { title: "Sales Enquiries", count: 13, color: "red" },
          ];
          break;
        default:
          this.jobStatus = "low";
      }
      this.disableOtherImpectBars(clickedIndex);
    },
    disableOtherImpectBars(selectedIndex) {
      const defaultColors = ["#c62828", "#e65100", "#558b2f"];
      const preColor = defaultColors.map((color, index) =>
        index === selectedIndex ? color : "#d3d3d3"
      );
      this.impactchartOptions = {
        ...this.impactchartOptions,
        colors: preColor,
      };
    },
    onBarClickEnquiryCategory(event, chartContext, config) {
      this.activeIndex = null;
      this.ticketsByPrioritychartOptions = {
        ...this.ticketsByPrioritychartOptions,
        colors: ["#c62828", "#e65100", "#558b2f"],
      };
      this.impactchartOptions = {
        ...this.impactchartOptions,
        colors: ["#c62828", "#e65100", "#558b2f"],
      };
      const clickedIndex = config.dataPointIndex;
      switch (clickedIndex) {
        case 0:
          this.jobType = "low";
          this.filterimpactseries = [14, 17, 20];
          this.filteredticketsByPriorityseries = [44, 17, 10];
          this.resolveDay = 20;
          this.resolveHours = 9;
          this.resolveMins = 30;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [18, 19, 13, 36, 12, 22],
            },
            {
              name: "Closed Jobs",
              data: [22, 21, 24, 18, 27, 3],
            },
          ];

          this.enguiryCategory = [
            { title: "Login Issues", count: 28, color: "green" },
            { title: "Software Bugs", count: 15, color: "blue" },
            { title: "App Issues", count: 35, color: "cyan" },
            { title: "Integrations Failures", count: 23, color: "orange" },
            { title: "API Issues", count: 15, color: "gray" },
            { title: "Service Cancellation", count: 14, color: "green" },
            { title: "Invoice Enquiries", count: 22, color: "blue" },
            { title: "Payment Issues", count: 15, color: "cyan" },
            { title: "Refund Requests", count: 4, color: "orange" },
            { title: "Sales Enquiries", count: 3, color: "red" },
          ];
          break;
        case 1:
          this.jobType = "medium";
          this.filterimpactseries = [23, 28, 19];
          this.filteredticketsByPriorityseries = [34, 27, 14];
          this.resolveDay = 15;
          this.resolveHours = 7;
          this.resolveMins = 20;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [38, 39, 13, 36, 33, 29],
            },
            {
              name: "Closed Jobs",
              data: [29, 28, 24, 18, 17, 23],
            },
          ];

          this.enguiryCategory = [
            { title: "Login Issues", count: 28, color: "green" },
            { title: "Software Bugs", count: 45, color: "blue" },
            { title: "App Issues", count: 25, color: "cyan" },
            { title: "Integrations Failures", count: 13, color: "orange" },
            { title: "API Issues", count: 15, color: "gray" },
            { title: "Service Cancellation", count: 24, color: "green" },
            { title: "Invoice Enquiries", count: 22, color: "blue" },
            { title: "Payment Issues", count: 25, color: "cyan" },
            { title: "Refund Requests", count: 14, color: "orange" },
            { title: "Sales Enquiries", count: 23, color: "red" },
          ];
          break;
        case 2:
          this.jobType = "high";
          this.filterimpactseries = [33, 62, 15];
          this.filteredticketsByPriorityseries = [34, 17, 20];
          this.resolveDay = 18;
          this.resolveHours = 2;
          this.resolveMins = 25;
          this.newClosedJobsseries = [
            {
              name: "New Jobs",
              data: [29, 28, 43, 18, 27, 23],
            },
            {
              name: "Closed Jobs",
              data: [38, 39, 13, 36, 33, 29],
            },
          ];
          this.enguiryCategory = [
            { title: "Login Issues", count: 18, color: "green" },
            { title: "Software Bugs", count: 25, color: "blue" },
            { title: "App Issues", count: 45, color: "cyan" },
            { title: "Integrations Failures", count: 33, color: "orange" },
            { title: "API Issues", count: 25, color: "gray" },
            { title: "Service Cancellation", count: 4, color: "green" },
            { title: "Invoice Enquiries", count: 12, color: "blue" },
            { title: "Payment Issues", count: 5, color: "cyan" },
            { title: "Refund Requests", count: 14, color: "orange" },
            { title: "Sales Enquiries", count: 13, color: "red" },
          ];
          break;
        default:
      }
      this.disableEnquiryCategoryBars(clickedIndex);
    },
    disableEnquiryCategoryBars(clickedIndex) {
      this.$nextTick(() => {
        const bars = document.querySelectorAll(
          ".enquiry-category .apexcharts-yaxis-label"
        );
        bars.forEach((bar, index) => {
          if (index === clickedIndex) {
            bar.classList.add("active-bar");
          } else {
            bar.classList.remove("active-bar");
            // bar.classList.add("inactive-bar");
          }
        });
      });
    },
    getBgColor(color) {
      switch (color) {
        case "cyan":
          return "#00bcd4";
        case "green":
          return "#4CAF50";
        case "red":
          return "#F44336";
        case "blue":
          return "#ff9800";
        case "orange":
          return "#ff9800";
        case "yellow":
          return "#ffeb3b";
        case "indigo":
          return "#3f51b5";
        default:
          return "white";
      }
    },
  },
};
</script>
<style scoped src="@/assets/sass/dashboard.scss" lang="scss">
@media screen and (min-width: 1200px) and (max-width: 1399px) {
  .v-application .text-h5 {
    font-size: 1.2rem !important;
  }
}
</style>
